import queryString from "query-string";

const urlToKey = url => `cache:${url}`;

const _getSession = ({ key: _key }) => {
  const key = urlToKey(_key);
  const _value = window.sessionStorage.getItem(key) || null;
  return typeof _value === "string" ? Number(_value) : undefined;
};

const _setSession = ({ key: _key, value }) => {
  const key = urlToKey(_key);
  window.sessionStorage.setItem(key, value);
  return value;
};

export const fetchPlacesCount = (): Function => (
  state,
  actions,
): Promise<void> => {
  const {
    api,
    clientID,
    places: {
      category: { id: categoryID },
    },
  } = state;

  const headers = new Headers({ authorization: state.authorization });
  const queryParameters = queryString.stringify({
    categoryID,
    pageNumber: 1,
    pageSize: 1,
    placeCountOnly: true,
  });
  const url = `${api}/v1/places/${clientID}?${queryParameters}`;
  const placeCountFromCache = _getSession({ key: url });

  if (typeof placeCountFromCache != "number") {
    const fetching = fetch(url, { headers });

    fetching
      .then(response => response.json())
      .then(({ placeCount }) => {
        _setSession({ key: url, value: placeCount });
        actions.setPlaceCount({ placeCount, isLoading: false });
      })
      .catch(reason => actions.setPlacesFailed({ reason }));
  } else {
    const placeCount = placeCountFromCache;
    return actions.setPlaceCount({ placeCount, isLoading: false });
  }

  return {
    ...state,
    places: {
      ...state.places,
      pagination: {
        ...state.places.pagination,
        isLoading: true,
        itemCount: undefined,
        pageCount: undefined,
      },
    },
  };
};
